import * as React from "react";

import { Doc } from "affinityUI/structures/doc";

import patientsSection from "./assets/Patients section in navigation bar.png";
export const PatientManagementSection: React.FC = () => {
  return (
    <Doc.Section title="Patient Management">
      <p>
        All information and tools related to the patients and blood test results are grouped under the “Patients”
        section in the navigation bar at the top of the screen.
      </p>
      <Doc.Illustration src={patientsSection} label="Patients section in navigation bar" />
    </Doc.Section>
  );
};
